import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';

import App from './containers/App/App';
import asyncComponent from './helpers/AsyncFunc';

const RestrictedRoute = ({ component: Component, isLoggedInCMS, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      isLoggedInCMS ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/signin',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);
const PublicRoutes = ({ history, isLoggedInCMS }) => {
  return (
    <ConnectedRouter history={history}>
      <div>
        <Route
          exact
          path={'/'}
          component={asyncComponent(() => import('./containers/Page/signin'))}
        />
        <Route
          exact
          path={'/signin'}
          component={asyncComponent(() => import('./containers/Page/signin'))}
        />
         <Route
          exact
          path={'/forgot-password'}
          component={asyncComponent(() => import('./containers/Page/forgotpassword'))}
        />
        <RestrictedRoute
          path="/dashboard"
          component={App}
          isLoggedInCMS={isLoggedInCMS}
        />
      </div>
    </ConnectedRouter>
  );
};

export default connect(state => ({
  isLoggedInCMS: state.Auth.isLoggedInCMS
}))(PublicRoutes);
